import React, { useState, useEffect, useContext, useCallback } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import ChatIcon from '@material-ui/icons/Chat';

import TicketsManagerTabs from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";
import TicketsEmptyState from "../../components/TicketsEmptyState";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles(theme => ({
    header: {
    },
    content: {
        overflow: "auto"
    },
}));

const TicketAdvanced = (props) => {
	const classes = useStyles();
	const { ticketId } = useParams();
	const [option, setOption] = useState(0);
    const { currentTicket, setCurrentTicket } = useContext(TicketsContext)
    // contadores e troca de aba usados pela tela "sem chat aberto" (igual ao desktop)
    const [counts, setCounts] = useState({ open: 0, pending: 0 })
    const [tabRequest, setTabRequest] = useState(null)

    const handleCountsChange = useCallback((next) => {
        setCounts((prev) => ({ ...prev, ...next }))
    }, [])

    useEffect(() => {
        if(currentTicket.id !== null) {
            setCurrentTicket({ id: currentTicket.id, uuid: currentTicket.uuid, code: '#open' })
        }
        if (!ticketId) {
            setOption(1)
        }
        return () => {
            setCurrentTicket({ id: null, code: null })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (currentTicket.id !== null) {
            setOption(0)
        }
    }, [currentTicket])

	const renderPlaceholder = () => {
		return <TicketsEmptyState
			openCount={counts.open}
			pendingCount={counts.pending}
			hint="Toque em Chats para escolher uma conversa."
			onSelectTab={(tab) => {
				setTabRequest({ tab, at: Date.now() })
				setOption(1)
			}}
		/>
	}

	const renderMessageContext = () => {
		if (ticketId) {
			return <Ticket />
		}
		return renderPlaceholder()
	}

	const renderTicketsManagerTabs = () => {
		return <TicketsManagerTabs onCountsChange={handleCountsChange} tabRequest={tabRequest} />
	}

	return (
        <TicketAdvancedLayout>
            <Box className={classes.header}>
                <BottomNavigation
                    value={option}
                    onChange={(event, newValue) => {
                        setOption(newValue);
                    }}
                    showLabels
                    className={classes.root}
                >
                    <BottomNavigationAction label="Ticket" icon={<ChatIcon />} />
                    <BottomNavigationAction label="Chats" icon={<QuestionAnswerIcon />} />
                </BottomNavigation>
            </Box>
            <Box className={classes.content}>
                { option === 0 && renderMessageContext() }
                {/* Sem chat aberto, a lista fica montada (oculta) para alimentar os
                    contadores da tela vazia e não perder o estado ao trocar de aba */}
                { (option === 1 || !ticketId) && (
                    <Box style={{ display: option === 1 ? "contents" : "none" }}>
                        { renderTicketsManagerTabs() }
                    </Box>
                )}
            </Box>
        </TicketAdvancedLayout>
	);
};

export default TicketAdvanced;
